import { render, staticRenderFns } from "./handgrading_container.vue?vue&type=template&id=b3bd1a9e&scoped=true&"
import script from "./handgrading_container.vue?vue&type=script&lang=ts&"
export * from "./handgrading_container.vue?vue&type=script&lang=ts&"
import style0 from "./handgrading_container.vue?vue&type=style&index=0&id=b3bd1a9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd1a9e",
  null
  
)

export default component.exports